/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react';
import { Tooltip as AntTooltip } from 'antd';

export const Tooltip: typeof AntTooltip = forwardRef((props, ref) => (
  <AntTooltip ref={ref} overlayClassName={props.className} {...props} />
));
